import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { MapPin, Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/Button';
export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
      setMobileMenuOpen(false);
    }
  };
  return <header className="sticky top-0 z-50 bg-white border-b border-neutral-200 shadow-sm" data-id="element-85">
      {' '}
      <div className="container mx-auto px-4" data-id="element-86">
        <div className="flex items-center justify-between py-2" data-id="element-87">
          {/* Logo */}
          <Link to="/" className="flex items-center" data-id="element-88">
            <div className="flex items-center gap-3" data-id="element-89">
              {' '}
              <img src="https://cdn.magicpatterns.com/uploads/oSSHgi3MjLQnsepvnPobTp/logo.png" alt="NTA Taekwondo Logo" className="h-16 w-auto" data-id="element-90" />
              <div className="flex flex-col" data-id="element-91">
                <span className="font-black text-xl text-neutral-900 leading-tight" data-id="element-92">
                  NTA Taekwondo
                </span>
                <span className="text-xs text-neutral-600 flex items-center gap-1" data-id="element-93">
                  <MapPin className="w-3 h-3" data-id="element-94" />
                  Grapevine, Texas
                </span>
              </div>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8" data-id="element-95">
            <Link to="/" className="text-neutral-700 hover:text-red-700 font-semibold transition-colors" data-id="element-96">
              Home
            </Link>
            <button onClick={() => scrollToSection('programs')} className="text-neutral-700 hover:text-red-700 font-semibold transition-colors" data-id="element-97">
              Programs
            </button>
            <button onClick={() => scrollToSection('reviews')} className="text-neutral-700 hover:text-red-700 font-semibold transition-colors" data-id="element-98">
              Reviews
            </button>
            <Link to="/contact" className="text-neutral-700 hover:text-red-700 font-semibold transition-colors" data-id="element-99">
              Contact
            </Link>
            <a href="tel:9725323400" className="flex items-center gap-2 text-red-700 hover:text-red-800 font-bold transition-colors" data-id="element-100">
              <Phone className="w-4 h-4" data-id="element-101" />
              (972) 532-3400
            </a>
          </nav>

          {/* CTA Button - Desktop */}
          <div className="hidden lg:block" data-id="element-102">
            <Button href="/signup" className="px-6 py-3 text-base" data-id="element-103" />
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="lg:hidden p-2 text-neutral-700 hover:text-red-700 transition-colors" aria-label="Toggle menu" data-id="element-104">
            {mobileMenuOpen ? <X className="w-6 h-6" data-id="element-105" /> : <Menu className="w-6 h-6" data-id="element-106" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="lg:hidden border-t border-neutral-200 py-4" data-id="element-107">
            <nav className="flex flex-col gap-4" data-id="element-108">
              <Link to="/" onClick={() => setMobileMenuOpen(false)} className="text-neutral-700 hover:text-red-700 font-semibold transition-colors py-2" data-id="element-109">
                Home
              </Link>
              <button onClick={() => scrollToSection('programs')} className="text-neutral-700 hover:text-red-700 font-semibold transition-colors py-2 text-left" data-id="element-110">
                Programs
              </button>
              <button onClick={() => scrollToSection('reviews')} className="text-neutral-700 hover:text-red-700 font-semibold transition-colors py-2 text-left" data-id="element-111">
                Reviews
              </button>
              <Link to="/contact" onClick={() => setMobileMenuOpen(false)} className="text-neutral-700 hover:text-red-700 font-semibold transition-colors py-2" data-id="element-112">
                Contact
              </Link>
              <a href="tel:9725323400" className="flex items-center gap-2 text-red-700 hover:text-red-800 font-bold transition-colors py-2" data-id="element-113">
                <Phone className="w-4 h-4" data-id="element-114" />
                (972) 532-3400
              </a>
              <Button href="/signup" fullWidth className="mt-2" data-id="element-115" />
            </nav>
          </motion.div>}
      </div>
    </header>;
}